import React, {useEffect, useState} from "react";
import "../App.css";

import Axios from "axios";
import {useNavigate} from "react-router-dom";

import {MDBBtn, MDBInput} from "mdb-react-ui-kit";

import 'react-datepicker/dist/react-datepicker.css'
import {backendPathAuth, backendPathOfficeEmployees} from "../Constants";
import TopNavbar from "../components/Navbar";
import {loadPermissions} from "../functions/permissions";



function NewOfficeEmployee() {
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [submitted, setSubmitted] = useState(false);

    const [writePermission, setWritePermission] = useState(false);
    const [readPermission, setReadPermission] = useState(false);


    const addOfficeEmployee = () => {
        setSubmitted(true);

        if (!firstName || !lastName) {
            return;
        }

        Axios.get(backendPathOfficeEmployees+"create-office-employee.php", {
            params: {
                firstName: firstName,
                lastName: lastName,
            }
        }).then(() => {
            console.log(firstName, lastName)
            navigate("/office-employees");
        });
    };

    useEffect(() => {
        loadPermissions(navigate, setReadPermission, setWritePermission);
    }, []);


    return (
        <div>
            <TopNavbar readPermissionInitial={readPermission} writePermissionInitial={writePermission}/>

            <div className="main">
                <div className="header">
                    <h2>Neuen Mitarbeiter hinzufügen</h2>
                </div>
                
                <div className='input-form'>

                    <MDBInput className="input" label='Vorname' type='text' onChange={(event) => {
                        setFirstName(event.target.value);
                    }} />
                    {(submitted && !firstName)?
                        <p className="validation-label">Vorname darf nicht leer sein.</p> : null
                    }

                    <MDBInput className="input" label='Nachname' type='text' onChange={(event) => {
                        setLastName(event.target.value);
                    }} />
                    {(submitted && !lastName)?
                        <p className="validation-label">Nachname darf nicht leer sein.</p> : null
                    }

                </div>

                <div className="footer">
                    <MDBBtn className="btn" type="submit" onClick={addOfficeEmployee}>Speichern</MDBBtn>
                </div>

            </div>
        </div>
    );
}

export default NewOfficeEmployee;